import useStore, { createStore } from "global-hook-store";

const dashboardStore = createStore({ organization: "", space: "" }, {});

export const useDashboardState = () => {
  const { state, setState } = useStore(dashboardStore);

  return { ...state, setState };
};
